import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { sendInvoiceDocument } from '../../../../services/request';
import { Box, Stack, Modal, Portal, Card, CardHeader, CardContent, TextField, Typography, Button, IconButton, Alert, LinearProgress } from '@mui/material';
import AttachmentIcon from '@mui/icons-material/Attachment';

import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const validationSchema = Yup.object({
  subject: Yup.string().required('To pole nie może być puste'),
  message: Yup.string().required('To pole nie może być puste')
});

const SendDocumentModal = ({ open, handleClose, data }) => {
  const { mutate, loading, error } = useMutation(sendInvoiceDocument);

  const handleSubmit = async values => {
    const { error } = await mutate(data.id, values);
    if (!error) {
      formik.resetForm();
      handleClose();
    }
  };

  const formik = useFormik({
    initialValues: {
      message: 'Witam serdecznie,\n\nw załączniku faktura. W razie niezgodności na fakturze proszę pisać na adres mailowy finanse@sun-sport.pl\n\nPozdrawiamy,\nSun Sport',
      subject: ''
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <Portal>
      <Modal open={open} onClose={handleClose}>
        <Card sx={{ ...style, width: 600 }}>
          <CardHeader
            title="Wyślij dokument"
            sx={{ textAlign: 'center' }}
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Typography variant="body2">e-mail: <span style={{ fontWeight: 'bold' }}>{data.send_to}</span></Typography>
            <Box height={20}/>
            <form onSubmit={formik.handleSubmit}>
              <TextField
                id="subject"
                label="Temat"
                fullWidth
                value={formik.values.subject}
                onChange={formik.handleChange}
                error={formik.errors.subject && formik.touched.subject}
                helperText={formik.errors.subject}
              />
              <Box height={20}/>
              <TextField
                id="message"
                multiline
                rows={8}
                label="Treść wiadomości"
                fullWidth
                value={formik.values.message}
                onChange={formik.handleChange}
                error={formik.errors.message && formik.touched.message}
                helperText={formik.errors.message}
              />
              <Box height={20}/>
              <Stack direction="row" spacing={1}>
                <AttachmentIcon color="primary"/>
                <Typography variant="subtitle2">{data.number}</Typography>
              </Stack>
              { error
                ? <>
                  <Box height={20}/>
                  <Alert variant="outlined" severity="error">Nie udało się wysłać dokumentu</Alert>
                </>
                : null}
              <Box height={20}/>
              {loading
                ? <LinearProgress />
                : <Button variant="contained" type="submit" fullWidth>Wyślij</Button>}
            </form>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );

};

export default SendDocumentModal;
